module.exports = __webpack_public_path__ + "static/img/build.dc08e82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/build.png
// module id = YuhJ
// module chunks = 0